import { useState } from "react";
import { User } from "../../Domain/Model/User";
import AuthAPIDataSourceImpl from "../../Data/DataSource/API/AuthAPIDataSource";
import {AuthRepositoryImpl } from "../../Data/Repository/AuthRepositoryImpl";
import { LoginUseCase } from "../../Domain/UseCase/LoginUseCase";

const authDataSourceImpl = new AuthAPIDataSourceImpl();
const authRepositoryImpl = new AuthRepositoryImpl(authDataSourceImpl);

const loginUseCase = new LoginUseCase(authRepositoryImpl);

export default function LoginViewModel() {
    const [dataUser, setDatauser] = useState<User>();

    async function loginUser(email: string, password: string) {
        try {
          let login = await loginUseCase.login(email, password);
          console.log(login);
          if(login){
            console.log("Usuario logeado");
            let datos = {
                email: login.email,
                id: login.id,
                isVerified: login.isVerified,
                roles: login.roles,
                userName: login.userName,
                userInfo: login.userInfo
            }
            await setDatauser(datos);
            console.log(dataUser);
           return login;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }

      return {
        loginUser,
        dataUser
      };
}